<template>
  <div>
    <v-chip
      v-for="v in value"
      :key="v.id"
      small
      >{{ v.name }}</v-chip
    >
  </div>
</template>

<script>
export default {
  props: {
    value: [Array],
  },
};
</script>